module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/04_shape-lg-9cba178b9cddcf7f25c80e7acc0481d5.png";